import { updateAbility } from '@/lib/casl'
import { authQueries } from '@/lib/services/auth/auth.query'
import * as Sentry from '@sentry/react'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated')({
  component: () => <AuthenticatedLayout />,
  // `beforeLoad` functions are called serially, whereas `loader` functions are called in parallel
  beforeLoad: async ({ context, location }) => {
    // Make sure we have the currently logged in user's info
    const authState = await context.queryClient.ensureQueryData(authQueries.user())

    if (!authState?.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          next: location.href,
          reason: 'session-expired',
        },
      })
    }

    if (authState?.user) {
      // Associate all requests for this user's session with the user
      Sentry.setUser({
        id: authState.user.id,
        email: authState.user.email,
        username: authState.user.name,
      })

      if (context.ability) {
        // Update roles/permissions of the user
        // This determines the behavior of all of the <Can> components in the app
        updateAbility(authState.user, context.ability)
      }
    }

    // Make the currently logged in user's info available to all child routes
    return { authState }
  },
})

const AuthenticatedLayout = () => {
  return <Outlet />
}
